/**
 * Authoritative terraforming match phase on {@link MatchSchemaTf.matchPhase}.
 * Bonus play stays on GrassGoalReached until a player leaves, the match times out,
 * or the last human leaves. Stay/leave is per-player, not a separate phase.
 */
export enum TerraformingMatchPhase {
  PlantingGrass = 0,
  GrassGoalReached = 1,
  Complete = 2
}
